<template>
    <div class="row">
        <div class="col-12">
            <label class="form-label">Dosya</label>
            <v-file-uploader v-model="value" :accept="['xlsx']" value-parameter="File"></v-file-uploader>
        </div>
        <template v-if="result != null">
            <template v-if="($safe(result,'Datas')|| []).length > 0">
                <div class="col-12 mt-1">
                    <h4 class="text-success font-weight-bolder">Başarılılar</h4>
                    <div class="table-responsive mb-0">
                        <table class="table table-bordered table-sm bordered-table mb-0">
                            <thead>
                                <tr>
                                    <th class="text-nworap">Gelir/Gider</th>
                                    <th class="text-nworap">Kasa Açıklaması</th>
                                    <th class="text-nworap">Muhasebe Hesap Adı</th>
                                    <th class="text-nworap">Muhasebe Kodu</th>
                                    <th class="text-nworap">Proje Kodu</th>
                                    <th class="text-nworap">Tarih</th>
                                    <th class="text-nworap text-right">Tutar (TL)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(e,i) in $safe(result,'Datas')|| []" :key="i">
                                    <td class="text-nowrap">{{ $safe(e,'Gelir_Gider') }}</td>
                                    <td class="text-nowrap">{{ $safe(e,'KasaAciklamasi') }}</td>
                                    <td class="text-nowrap">{{ $safe(e,'MuhasebeHesapAdi') }}</td>
                                    <td class="text-nowrap">{{ $safe(e,'MuhasebeKodu') }}</td>
                                    <td class="text-nowrap">{{ $safe(e,'ProjeKodu_G_R') }}</td>
                                    <td class="text-nowrap">{{ $safe(e,'Tarih') }}</td>
                                    <td class="text-nowrap text-right">{{ $safe(e,'Tutar') }}</td>
                                </tr>
                                <tr>
                                    <td class="bg-light text-right font-weight-bolder" colspan="6">Toplam</td>
                                    <td class="text-right font-weight-bolder">{{ total }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </template>
            <template v-if="($safe(result,'Errors')|| []).length > 0">
                <div class="col-12 mt-1">
                    <h4 class="text-danger font-weight-bolder">Hatalar</h4>
                    <div class="table-responsive mb-0">
                        <table class="table table-bordered table-sm bordered-table mb-0">
                            <thead>
                                <tr>
                                    <th class="text-center">Hücre</th>
                                    <th class="w-100">Hata</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(e,i) in $safe(result,'Errors')|| []" :key="i">
                                    <td class="text-center text-danger">{{ $safe(e,'Cell') }}</td>
                                    <td>{{ $safe(e,'Error') }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </template>
            <template v-if="($safe(result,'Errors')|| []).length == 0 && ($safe(result,'Datas')|| []).length == 0">
                <div class="col-12 mt-1 text-center">Kontrol edilecek bir veri bulunamaktadır.</div>
            </template>
        </template>
        <template v-if="saveResult != null">
            <template v-if="($safe(saveResult,'SuccededUploadList')|| []).length > 0">
                <div class="col-12 mt-1">
                    <h4 class="text-success font-weight-bolder">Başarılı Aktarımlar</h4>
                    <div class="table-responsive mb-0">
                        <table class="table table-bordered table-sm bordered-table mb-0">
                            <thead>
                                <tr>
                                    <th class="text-nworap">Gelir/Gider</th>
                                    <th class="text-nworap">Kasa Açıklaması</th>
                                    <th class="text-nworap">Muhasebe Hesap Adı</th>
                                    <th class="text-nworap">Muhasebe Kodu</th>
                                    <th class="text-nworap">Proje Kodu</th>
                                    <th class="text-nworap">Tarih</th>
                                    <th class="text-nworap">Tutar (TL)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(e,i) in $safe(saveResult,'SuccededUploadList')|| []" :key="i">
                                    <td class="text-nowrap">{{ $safe(e,'Gelir_Gider') }}</td>
                                    <td class="text-nowrap">{{ $safe(e,'KasaAciklamasi') }}</td>
                                    <td class="text-nowrap">{{ $safe(e,'MuhasebeHesapAdi') }}</td>
                                    <td class="text-nowrap">{{ $safe(e,'MuhasebeKodu') }}</td>
                                    <td class="text-nowrap">{{ $safe(e,'ProjeKodu_G_R') }}</td>
                                    <td class="text-nowrap">{{ $safe(e,'Tarih') }}</td>
                                    <td class="text-nowrap">{{ $safe(e,'Tutar') }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </template>
            <template v-if="($safe(saveResult,'FailedUploadList')|| []).length > 0">
                <div class="col-12 mt-1">
                    <h4 class="text-danger font-weight-bolder">Başarısız Aktarımlar</h4>
                    <div class="table-responsive mb-0">
                        <table class="table table-bordered table-sm bordered-table mb-0">
                            <thead>
                                <tr>
                                    <th class="text-nworap">Gelir/Gider</th>
                                    <th class="text-nworap">Kasa Açıklaması</th>
                                    <th class="text-nworap">Muhasebe Hesap Adı</th>
                                    <th class="text-nworap">Muhasebe Kodu</th>
                                    <th class="text-nworap">Proje Kodu</th>
                                    <th class="text-nworap">Tarih</th>
                                    <th class="text-nworap">Tutar (TL)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(e,i) in $safe(saveResult,'FailedUploadList')|| []" :key="i">
                                    <td class="text-nowrap">{{ $safe(e,'Gelir_Gider') }}</td>
                                    <td class="text-nowrap">{{ $safe(e,'KasaAciklamasi') }}</td>
                                    <td class="text-nowrap">{{ $safe(e,'MuhasebeHesapAdi') }}</td>
                                    <td class="text-nowrap">{{ $safe(e,'MuhasebeKodu') }}</td>
                                    <td class="text-nowrap">{{ $safe(e,'ProjeKodu_G_R') }}</td>
                                    <td class="text-nowrap">{{ $safe(e,'Tarih') }}</td>
                                    <td class="text-nowrap">{{ $safe(e,'Tutar') }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
import VFileUploader from '@/components/v-file-uploader/VFileUploader.vue'
export default {
    components:{
        VFileUploader
    },
    props:{
        value:Object,
        result:Object,
        saveResult:Object
    },
    computed:{
        total(){
            const datas = this.$safe(this.result,'Datas') || []
            if(datas.length > 0){
                return datas.reduce((sum,i)=>{
                    sum += (Number(i?.Tutar || 0))
                    return sum
                },0)
            }else return 0
        }
    }
}
</script>